<template>
  <div>
    <div class="mb-4">
      <!-- :style="SirketKasa?'height: 75vh':'height: 35vh'" -->
      <KasaGrafik v-if="Grafik" :Grafik="Grafik"></KasaGrafik>
      <SiteKasa v-if="SiteKasa" :SirketKasa="SirketKasa" :AltToplam="Bakiye" :SiteKasa="SiteKasa"></SiteKasa>
    </div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-tabs type="border-card" class="tab-p0" :class="SiteKasa?'':' tabs-center'">
      <el-tab-pane v-if="SiteHesap" :label="SiteHesap.BinaBilgi.Adi?SiteHesap.BinaBilgi.Adi:'GENEL'" :lazy=true>
        <KasaTable :data="SiteHesap" :Bina_id="SiteHesap.BinaBilgi.id"></KasaTable>
      </el-tab-pane>
      <el-tab-pane v-for="k in Kasalar" v-if="k.Kasa" :label="k.BinaBilgi.Adi" :lazy=true>
        <KasaTable :data="k" :Bina_id="k.BinaBilgi.id"></KasaTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Yukleniyor from "../../../../../Doc/Yukleniyor";
  import KasaGrafik from "./KasaGrafik";
  import SiteKasa from "./SiteKasa";
  import KasaTable from "./KasaTable";

  export default {
    components: {KasaTable, SiteKasa, KasaGrafik, Yukleniyor},
    props: ["data", "Bina_id"],
    data() {
      return {
        lo: false,
        Kasalar: null,
        Grafik: null,
        SiteKasa: null,
        KasaDetay: null,
        SiteHesap: null,
        SirketKasa: null,
        Bakiye: {
          Gelir: 0,
          Gider: 0,
          Bakiye: 0,
          Virman: 0,
          Bloke: 0
        }
      }
    },
    methods: {
      SayfaYukle() {
        this.lo = true;
        var Url = null;
        if (this.Bina_id === 'Sirket') Url = 'yonetim/sirket/kasa'; else Url = 'yonetim/bina/ekran/' + this.Bina_id + '/kasa';
        this.$store.dispatch("Get", {path: Url})
          .then(response => {
            if (response.Durum === 'OK') {
              if (response.Grafik) this.Grafik = response.Grafik;
              if (response.SiteKasa) this.SiteKasa = response.SiteKasa;
              if (response.SiteHesap) this.SiteHesap = response.SiteHesap;
              if (response.SirketKasa) this.SirketKasa = response.SirketKasa;
              this.Kasalar = response.Liste;
              this.Bakiye = response.Bakiye;
              this.lo = false;
              this.$emit('KasaBakiye', response.Bakiye);
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },


    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Kasalar.vue